import { imageBaseUrl } from '@/settings'

/**
 * 处理图片URL，如果是相对路径则拼接域名
 * @param {string} url - 图片URL
 * @returns {string} - 完整的图片URL
 */
export function getImageUrl(url) {
  if (!url) {
    return ''
  }

  // 如果已经是完整URL（包含http或https），直接返回
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url
  }

  // 如果是相对路径，拼接域名
  if (url.startsWith('/')) {
    return `${imageBaseUrl}${url}`
  } else {
    return `${imageBaseUrl}/${url}`
  }
}

/**
 * 批量处理图片URL数组
 * @param {Array} urls - 图片URL数组
 * @returns {Array} - 处理后的完整图片URL数组
 */
export function getImageUrls(urls) {
  if (!Array.isArray(urls)) {
    return []
  }

  return urls.map(url => getImageUrl(url))
}

/**
 * 处理对象中的图片字段
 * @param {Object} obj - 包含图片字段的对象
 * @param {Array} imageFields - 需要处理的图片字段名数组
 * @returns {Object} - 处理后的对象
 */
export function processImageFields(obj, imageFields = ['avatar', 'image', 'cover', 'thumbnail']) {
  if (!obj || typeof obj !== 'object') {
    return obj
  }

  const processedObj = { ...obj }

  imageFields.forEach(field => {
    if (processedObj[field]) {
      if (Array.isArray(processedObj[field])) {
        processedObj[field] = getImageUrls(processedObj[field])
      } else {
        processedObj[field] = getImageUrl(processedObj[field])
      }
    }
  })

  return processedObj
}
